export interface ScrollData {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}
export type CallbackType = (e: ScrollData) => void;

export class EventStore {
  static callbacks: Array<CallbackType> = [];

  static subscribe(callback: CallbackType): void {
    EventStore.callbacks.push(callback);
  }

  static unsubscribe(callback: CallbackType): void {
    EventStore.callbacks = EventStore.callbacks.filter(v => v !== callback);
  }

  static emit(e: ScrollData): void {
    EventStore.callbacks.forEach(callback => {
      callback(e);
    });
  }
}
